import React from "react";
import Styles from "./fileStatus/FileStatus.module.scss"
import XLS from './fileStatus/xls.svg'
import CSV from './fileStatus/csv.svg'
import {showFileName} from "../../../../util/util";


const FileStatus = ({removeFileFromList, mimeType, source,file}) => {
    return (
        <div className={`${Styles.file} d-flex align-items-center`}>
            <img width={34} height={38} src={file.name.toLowerCase().includes('.csv') ? CSV : XLS} title={mimeType} alt={mimeType}/>
            <div className="ml-3">
                <p style={{width:217}} className="dark-gary-2 f14 fw500" title={file.name}>{showFileName(file.name)}</p>
                {file.status === 'done' ?
                    <p className="dark-gary-2 f12 fw500">Local Host | {file.size} KB</p>
                    :
                    <div className={Styles.progressContainer}>
                        <p className={Styles.percentage}>{file.percentage}%</p>
                        <div style={{width:file.percentage + '%'}} className={Styles.progress}></div>
                    </div>
                }
            </div>
            <div className={Styles.icon}>
                {
                    file.status === 'done' ?
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.2"
                                  d="M16.3402 2H7.67024C4.28024 2 2.00024 4.38 2.00024 7.92V16.09C2.00024 19.62 4.28024 22 7.67024 22H16.3402C19.7302 22 22.0002 19.62 22.0002 16.09V7.92C22.0002 4.38 19.7302 2 16.3402 2Z"
                                  fill="#0DFDC5"/>
                            <path
                                d="M10.8133 15.248C10.5893 15.248 10.3653 15.163 10.1943 14.992L7.82132 12.619C7.47932 12.277 7.47932 11.723 7.82132 11.382C8.16332 11.04 8.71632 11.039 9.05832 11.381L10.8133 13.136L14.9413 9.00796C15.2833 8.66596 15.8363 8.66596 16.1783 9.00796C16.5203 9.34996 16.5203 9.90396 16.1783 10.246L11.4323 14.992C11.2613 15.163 11.0373 15.248 10.8133 15.248Z"
                                fill="#0DFDC5"/>
                        </svg>
                        :
                        <svg onClick={removeFileFromList} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.4"
                                  d="M16.3399 2H7.66988C4.27988 2 1.99988 4.38 1.99988 7.92V16.09C1.99988 19.62 4.27988 22 7.66988 22H16.3399C19.7299 22 21.9999 19.62 21.9999 16.09V7.92C21.9999 4.38 19.7299 2 16.3399 2Z"
                                  fill="#C2C7ED"/>
                            <path
                                d="M15.0156 13.7705L13.2366 11.9925L15.0146 10.2145C15.3566 9.8735 15.3566 9.3185 15.0146 8.9775C14.6726 8.6335 14.1196 8.6345 13.7776 8.9765L11.9986 10.7545L10.2196 8.9745C9.87758 8.6325 9.32358 8.6345 8.98158 8.9745C8.64058 9.3165 8.64058 9.8715 8.98158 10.2125L10.7616 11.9925L8.98558 13.7675C8.64358 14.1095 8.64358 14.6645 8.98558 15.0045C9.15658 15.1765 9.37958 15.2615 9.60358 15.2615C9.82858 15.2615 10.0516 15.1765 10.2226 15.0055L11.9986 13.2295L13.7786 15.0085C13.9496 15.1795 14.1726 15.2645 14.3966 15.2645C14.6206 15.2645 14.8446 15.1785 15.0156 15.0085C15.3576 14.6665 15.3576 14.1125 15.0156 13.7705Z"
                                fill="#70789E"/>
                        </svg>
                }
            </div>
        </div>
    )
}
export default FileStatus;